
export const sidebarUser = {
  'backoffice.sidebarUser.sections.dashboard.title': 'Dashboard',
  'backoffice.sidebarUser.sections.dashboard.items.summary': 'Riepilogo',
  'backoffice.sidebarUser.sections.myCommunity.title': 'La Mia Comunità',
  'backoffice.sidebarUser.sections.myCommunity.items.genealogyTree': 'Albero Genealogico',
  'backoffice.sidebarUser.sections.myCommunity.items.communityMembers': 'Membri della Comunità',
  'backoffice.sidebarUser.sections.investmentAccounts.title': 'Conti di Investimento',
  'backoffice.sidebarUser.sections.investmentAccounts.items.myAccounts': 'I Miei Conti',
  'backoffice.sidebarUser.sections.investmentAccounts.items.addAccount': 'Aggiungi Conto',
  'backoffice.sidebarUser.sections.myProfits.title': 'I Miei Profitti',
  'backoffice.sidebarUser.sections.myProfits.items.accountsProfitSummary': 'Riepilogo Profitti dei Conti',
  'backoffice.sidebarUser.sections.myProfits.items.accountsProfitHistory': 'Cronologia Profitti dei Conti',
  'backoffice.sidebarUser.sections.myProfits.items.commissionsSummary': 'Riepilogo Commissioni',
  'backoffice.sidebarUser.sections.myProfits.items.commissionsHistory': 'Cronologia Commissioni',
  'backoffice.sidebarUser.sections.myProfits.items.commissionsPaymentHistory': 'Cronologia Pagamenti Commissioni',
  'backoffice.sidebarUser.sections.myProfits.items.myPaymentMethods': 'I Miei Metodi di Pagamento',
  'backoffice.sidebarUser.sections.startInvesting.title': 'Inizia a Investire',
  'backoffice.sidebarUser.sections.startInvesting.items.createRadexAccount': 'Crea Account Radex Markets',
  'backoffice.sidebarUser.sections.startInvesting.items.joinPammInstitutional': 'Unisciti al PAMM Institutional Trading',
  'backoffice.sidebarUser.sections.startInvesting.items.joinPammSpartanAi': 'Unisciti al PAMM Spartan AI',
  'backoffice.sidebarUser.sections.startInvesting.items.accessPammAccount': 'Accedi al tuo Account PAMM',
  'backoffice.sidebarUser.sections.tutorials.title': 'Tutorial',
  'backoffice.sidebarUser.sections.myProfile.title': 'Il Mio Profilo',
  'backoffice.sidebarUser.sections.myProfile.items.theClubUserProfile': 'Profilo Utente The Club',
  'backoffice.sidebarUser.sections.myProfile.items.personalInformation': 'Le Mie Informazioni Personali',
  'backoffice.sidebarUser.sections.myProfile.items.paymentMethods': 'I Miei Metodi di Pagamento',
  'backoffice.sidebarUser.sections.myProfile.items.referralLink': 'Il Mio Link di Riferimento',
  'backoffice.sidebarUser.sections.support.title': 'Supporto',
  'backoffice.sidebarUser.sections.support.items.helpCenter': 'Centro Assistenza',
  'backoffice.sidebarUser.signOut': 'Disconnetti'
};
